export enum DocumentManagerActions {
  SEND_ALL_DOCUMENTS = 'send_all_documents',
  SYNCHRONIZE_DOCUMENTS = 'synchronize_documents',
}
